//#region src/theme/theme-model.ts
var PD_THEME_CHANGED_EVENT = "pd-theme-changed";
var THEME_ATTRIBUTE = "theme";
//#endregion
export { PD_THEME_CHANGED_EVENT, THEME_ATTRIBUTE };
